const allLeadsModule = {
  state: {
    items: null,
    pagination: null,
    leads_forms: null,
    leads_statuses: {
      show: true,
      items: [
        {
          name: 'all_leads.lead.status.new',
          value: 'new'
        },
        {
          name: 'all_leads.lead.status.contacted',
          value: 'contacted'
        },
        {
          name: 'all_leads.lead.status.customer',
          value: 'customer'
        },
        {
          name: 'all_leads.lead.status.manager',
          value: 'manager'
        },
        {
          name: 'all_leads.lead.status.regular',
          value: 'regular'
        },
        {
          name: 'all_leads.lead.status.wholesale',
          value: 'wholesale'
        }
      ]
    },
  },
  mutations: {
    setAllleads (state, data) {
      state.items = data
    },
    setAllleadsPagination (state, data) {
      state.pagination = data
    },
    setLeadSummary (state, data) {
      if(!state[data.id]) {
        state[data.id] = {
          summary: data
        }
      }
      else {
        state[data.id].summary = data
      }
    },
    setLeadVisits (state, data) {
      if(!state[data.lead_id]) {
        state[data.lead_id] = {
          visits: {
            list: data.visits,
            pagination: data.pagination
          }
        }
      }
      else {
        if(!state[data.lead_id].visits) {
          state[data.lead_id].visits = {
            list: data.visits,
            pagination: data.pagination
          }
        }
        else {
          state[data.lead_id].visits.list = data.visits
          if (data.pagination) {
            state[data.lead_id].visits.pagination = data.pagination
          }
        }
      }
    },
    setLeadVisitsSummary (state, data) {
      if(!state[data.lead_id]) {
        state[data.lead_id] = {
          visits: {
            summary: data.summary
          }
        }
      }
      else {
        if(!state[data.lead_id].visits) {
          state[data.lead_id].visits = {
            summary: data.summary
          }
        }
        else {
          state[data.lead_id].visits.summary = data.summary
        }
      }
    },
    setLeadVisitInfo (state, data) {
      if(!state[data.lead_id]) {
        state[data.lead_id] = {
          visits: {
            info: {}
          }
        }
        state[data.lead_id].visits.info[data.visit_id] = data.visit_info
      }
      else {
        if(!state[data.lead_id].visits) {
          state[data.lead_id].visits = {
            info: {}
          }
          state[data.lead_id].visits.info[data.visit_id] = data.visit_info
        }
        else {
          if(!state[data.lead_id].visits.info) {
            state[data.lead_id].visits.info = {}
            state[data.lead_id].visits.info[data.visit_id] = data.visit_info
          }
          else {
            state[data.lead_id].visits.info[data.visit_id] = data.visit_info
          }
        }
      }
    },
    setTimeline (state, data) {
      if(!state[data.lead.id]) {
        state[data.lead.id] = {
          timeline: data
        }
      }
      else {
        state[data.lead.id].timeline = data
      }
    },
    setLeadForms (state, data) {
      if(!state[data.lead_id]) {
        state[data.lead_id] = {
          forms: {
            list: data.filled_forms,
            pagination: data.pagination
          }
        }
      }
      else {
        state[data.lead_id].forms = {
          list: data.filled_forms,
          pagination: data.pagination
        }
      }
    },
    setLeadsFormsList (state, leads_forms) {
      state.leads_forms = leads_forms
    }
  },
  actions: {

  },
  getters: {
    getAllLeads: (state) => {
      return state.items
    },
    getAllLeadsPagination: (state) => {
      return state.pagination
    },
    getLeadById: (state) => (id) => {
      if (state[id]) {
        return state[id]
      }
      else {
        return null
      }
    },
    getLeadsFormsList: (state) => {
      return state.leads_forms
    },
    getLeadsStatuses: (state) => {
      return state.leads_statuses
    }
  }
}

export default allLeadsModule



// WEBPACK FOOTER //
// ./src/store/modules/all_leads.js